module.exports = __webpack_public_path__ + "img/benefit_2.29b21408.svg";